import { CgProfile } from "react-icons/cg";
import { BsPlus } from "react-icons/bs";
import "./header.css";

const Header = () => {
  return (
    <nav className="top-nav">
      <ul className="menu">
        <li className="logo">
          <h1>
            <a href="/" className="header-title">
              ROAMEO MUSIC
            </a>
          </h1>
        </li>
        <li>
          <a href="https://roameomusic.com/" className="header-link" target="_blank">
            About
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
